import {Component, OnInit} from '@angular/core';
import {MalihuScrollbarService} from 'ngx-malihu-scrollbar';
import {EnvService} from './services/env.service';
import {USSDGWSimulatorService} from './services/ussdgw-simulator.service';

@Component({
  selector: 'app-root',
  template: `
    <ngx-spinner
      color="grey"
      size="large" type="line-spin-fade"></ngx-spinner>
    <ngx-loading-bar [height]="'4px'" [color]="'red'"></ngx-loading-bar>
    <router-outlet></router-outlet>`
})

export class AppComponent implements OnInit {
  constructor(private mScrollbarService: MalihuScrollbarService, private env: EnvService, private ussdgw_simulator_socket: USSDGWSimulatorService) {
  }

  ngOnInit() {
    // console.log(this.env);
    // this.mScrollbarService.initScrollbar(document.body, {setWidth:23});
      this.ussdgwSocketListener();

  }
  ussdgwSocketListener() {
    if (!this.ussdgw_simulator_socket.ussdgw_simulator) {
      return;
    }
    this.ussdgw_simulator_socket.listen('test').subscribe((data) => {
    });

  }
}
